import { twoBtnPopupCreator } from 'components/popups/ConfirmPopup/helper';

const escalateRecommendationPopup = ({ onConfirm, currentTicketSMBName, alertTitle }) => {
  return twoBtnPopupCreator({
    content: {
      main: `${currentTicketSMBName} wants us to escalate tickets about '${alertTitle}'`,
      subText: ['Is that what the customer is asking about?'],
    },
    btnConfig: {
      dismiss: 'No',
      confirm: 'Yes, escalate',
    },
    onConfirm: onConfirm,
  });
};

export default escalateRecommendationPopup;
